module.exports = __webpack_public_path__ + "img/banner_bag_49e3d36.webp";